import { X, ShieldCheck } from 'lucide-react';
import { useProfile } from '../../../../../context/profile/ProfileContext';

const SubscriptionManageCard = () => {
  const {
    subscription,
    effectiveSub,
    isTrialUser,
    setShowCancelModal,
    handleResumeSubscription,
    navigate
  } = useProfile();

  return (
    <>
      {!isTrialUser && (
        <div className="bg-white rounded-2xl sm:rounded-3xl border border-gray-100 p-4 sm:p-6 lg:p-7 shadow-sm">
          <div className="border-b border-slate-100 pb-3.5 sm:pb-4 mb-3.5 sm:mb-4">
            <h2 className="font-semibold text-slate-900 text-sm sm:text-base">Manage subscription</h2>
          </div>

          <div className="space-y-3">
            {effectiveSub?.status === 'paused' || effectiveSub?.status === 'cancelled' ? (
              <div className="p-3 border border-[#067978]/20 rounded-xl bg-[#067978]/5 flex flex-col items-stretch">
                <span className="text-xs font-semibold text-slate-600 mb-2">
                  Reactivate to restore all active Pro feature accesses.
                </span>
                <button
                  onClick={() => {
                    const activePlanId = subscription?.plan_id?._id || subscription?.plan_id;
                    if (activePlanId) {
                      navigate(`/checkout?plan=${activePlanId}&interval=${subscription?.billing_interval || 'month'}&from=profile&mode=reactivate`);
                    } else {
                      handleResumeSubscription();
                    }
                  }}
                  className="w-full py-2 bg-[#067978] hover:bg-[#05605f] text-white rounded-lg text-xs font-semibold transition-all cursor-pointer"
                >
                  Reactivate Subscription
                </button>
              </div>
            ) : (
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2.5 py-1">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-xl bg-rose-50 text-rose-600 flex items-center justify-center shrink-0">
                    <X size={16} />
                  </div>
                  <div>
                    <b className="block text-sm font-semibold text-slate-800">Cancel subscription</b>
                    <span className="text-xs text-slate-500">Keeps working until cycle ends, then stops.</span>
                  </div>
                </div>
                <button
                  onClick={() => setShowCancelModal(true)}
                  className="px-3.5 py-1.5 bg-slate-50 hover:bg-rose-50 text-slate-700 hover:text-rose-600 rounded-xl font-semibold text-xs border border-slate-200 hover:border-rose-200 transition-all flex items-center justify-center gap-1.5 shadow-2xs active:scale-95 cursor-pointer self-start sm:self-auto whitespace-nowrap"
                >
                  <X size={12} className="text-slate-500" />
                  <span>Cancel</span>
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* In-Trip cover banner */}
      <div className="bg-teal-50 border border-teal-100 p-3.5 sm:p-4 rounded-2xl flex gap-3 items-start text-[#067978] text-xs">
        <ShieldCheck className="shrink-0 mt-0.5" size={18} />
        <div className="leading-relaxed font-normal">
          <b>Active In-Trip Protection:</b> All active trips on generated vouchers stay 100% active with live tracking and vendor access for your travellers.
        </div>
      </div>
    </>
  );
};

export default SubscriptionManageCard;
